import { pipe } from 'fp-ts/function';
import { getCookie } from 'cookies-next';
import { Screen, showScreen } from '../EventBus';
import { postJson, send } from './HttpClient';
import { HttpResponseException } from './exceptions/HttpResponseException';
import { UNAUTHORIZED } from './status';
const AUTH_STATE_KEY = '__oauthState';
let globalAuth;
// Initialize the auth state on window if it doesn't exist yet
if (typeof window !== 'undefined') {
    if (!window[AUTH_STATE_KEY]) {
        window[AUTH_STATE_KEY] = {
            refreshTokenPromise: null,
            failedToAuthorize: false,
            retries: 0,
        };
    }
    globalAuth = window[AUTH_STATE_KEY];
}
const handleRefreshTokenPromise = async (promise) => {
    try {
        return await promise;
    }
    catch (error) {
        if (error instanceof HttpResponseException &&
            error.status === UNAUTHORIZED) {
            // If auth server failed to authorize it makes no sense to retry,
            // we ask user to login again
            globalAuth.failedToAuthorize = true;
            showScreen({
                screen: Screen.SIGN_IN,
            });
        }
        else {
            // if it is not a server authorization logic error we can try to refresh again
            globalAuth.retries += 1;
        }
        return false;
    }
};
export const refreshTokenWithGlobalPromise = async () => {
    // Should be enabled only on the browser
    if (!globalAuth) {
        return false;
    }
    // If auth server has already failed to refresh the tokens, don't try again
    if (globalAuth.failedToAuthorize) {
        return false;
    }
    // We can try a couple of times in case of network errors, etc
    if (globalAuth.retries >= 2) {
        return false;
    }
    const expirationCookie = getCookie('oauth_token_expiration');
    // expiration cookie is the only one cookie related to oauth that can be readed from script
    // so we check it to understand if the oauth flow is enabled, and it makes sense to refresh
    if (!expirationCookie) {
        return false;
    }
    // If there is an ongoing refresh request return it instead of creating a new one
    if (globalAuth.refreshTokenPromise) {
        return handleRefreshTokenPromise(globalAuth.refreshTokenPromise);
    }
    try {
        globalAuth.refreshTokenPromise = pipe(postJson('/oauth/token', { grant_type: 'refresh_token' }), send(false, false, true)).then(() => {
            globalAuth.failedToAuthorize = false;
            globalAuth.retries = 0;
            return true;
        });
        return await handleRefreshTokenPromise(globalAuth.refreshTokenPromise);
    }
    finally {
        globalAuth.refreshTokenPromise = null;
    }
};
